import React from "react";
import * as T from "prop-types";

import { Field, Inputs } from "2g-form";

import { ADMIN } from "b2b/api/paths";
import { Produkt } from "b2b/renderers/ciselnik/";

import useMessages from "./i18n/useMessages";

export function ACProdukty({ ...props }) {
  const {
    produktyLabel,
    produktyLabelMultiple,
    produktyPlaceholder,
    produktyPlaceholderMultiple
  } = useMessages();
  return (
    <Field
      component={Inputs.AutoComplete}
      url={ADMIN.produkty()}
      rendererSelected={Produkt}
      rendererOption={Produkt}
      loadOnce
      staticKey={["nazevCs", "nazevEn"]}
      minChars={0}
      label={props.multiple ? produktyLabelMultiple() : produktyLabel()}
      placeholder={
        props.multiple ? produktyPlaceholderMultiple() : produktyPlaceholder()
      }
      descriptionRenderer={Produkt}
      {...props}
    />
  );
}

ACProdukty.propTypes = {
  multiple: T.bool
};

export default React.memo(ACProdukty);
